import { Injectable } from "@angular/core";
import { HttpService } from "../../../core/shared/http.service";
import { Observable } from "rxjs";
import { HttpContentTypes } from "src/app/core/shared/http-content-types.enum";
import { DataEndChannelError } from "../../../project/shared/interfaces/data-end-channel-error.interface";
import { SmartMicroCommand } from "../interfaces/smart-micro-command.interface";
import { WeatherDataItem } from "../interfaces/weatherDataItem";


@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  constructor(private httpService: HttpService) { }

  public getChannelErrors(deviceId: number): Observable<DataEndChannelError[]> {
    return this.httpService.get<DataEndChannelError[]>('Tls/Device/GetChannelStatus?deviceId=' + deviceId);
  }

  public resetDevice(guid: string, deKanal: any): Observable<any> {
    const data = new FormData();
    var deKanalArr = deKanal;
    data.append('guid', guid.toString());
    for (var i = 0; i < deKanalArr.length; i++) {
      data.append('deKanalArr[]', deKanalArr[i]);
    }

    return this.httpService.get('Tls/Device/Reset?guid=' + guid.toString() + '&deKanal=' + deKanal.toString(), true);
  }

  public refreshDataFromChannels(guid: string): Observable<any> {
    return this.httpService.get<any>('Tls/Device/RefreshDataFromChannels?guid=' + guid);
  }

  public learnSmartMicro(command: SmartMicroCommand): Observable<any> {
    return this.httpService.post<any>('Tls/Device/LearnSmartMicro', command);
  }

  public setSmartMicroEVAAppStatus(command: SmartMicroCommand): Observable<any> {
    return this.httpService.post<any>('Tls/Device/SetSmartMicroEVAAppStatus', command);
  }

  public getAllChannelErrorsByGroupId(groupId: number): Observable<any> {
    return this.httpService.get<any>('Tls/Device/GetAllChannelErrorsByGroupId?groupid=' + groupId);
  }

  public getSolarDetailsBySamIdForNewVersion(samId: number): Observable<any> {
    return this.httpService.get<any>('Tls/Device/GetSolarDetailsBySamIdForNewVersion?samId=' + samId);
  }
  /** Detail data of the weather channel of one route station, addressed by its guid. */
  public getWeatherDataDetailsByGuid(guid: string): Observable<WeatherDataItem> {
    return this.httpService.get<WeatherDataItem>('Tls/Device/GetWeatherDetailData?guid=' + guid);
  }
 /**
  * ACHTUNG: Einziger Nutzer ist die bewusst deaktivierte Geräte-Karte
  * (/device/map, Tab-Link auskommentiert). Die Route
  * GetAllRouteStationsDeviceParamsShort hatte Performance-Probleme — vor einer
  * Reaktivierung der Karte muss eine neue, robuste und performante Route
  * entwickelt und die DeviceMap darauf umgestellt werden.
  */
 public getAllRouteStationsWithParams(): Observable<any> {
    return this.httpService.get<any>('Tls/Device/GetAllRouteStationsDeviceParamsShort?withDeChannel=true');
  }

  public setAdecHeightOffset(deviceId: number, deKanal: number, height: number, offset: number): Observable<any> {
    return this.httpService.post<any>('Tls/Device/setAdecHeightOffset', {
      deviceId: deviceId,
      deKanal: deKanal,
      height: height,
      offset: offset
    });
  }

}
